import { useQuery } from '@tanstack/react-query';
import { folderService } from '../services/folderService';

export function useBreadcrumb(folderId: string | undefined) {
  return useQuery({
    queryKey: ['breadcrumb', folderId],
    queryFn: () => folderService.getBreadcrumb(folderId!),
    enabled: !!folderId,
  });
}
